// https://vuex.vuejs.org/en/getters.html

export default {
  user(state) {
    return state.user;
  },
  userID(state) {
    return state.userID;
  },
  currentUser(state) {
    return state.currentUser;
  },
  getToken(state) {
    return state.idToken;
  },
  isAuthenticated(state) {
    return state.idToken !== null;
  },
  group(state) {
    return !state.user ? false : state.user.group;
  },
  loading(state) {
    return state.loading;
  },
  pagination(state) {
    return state.pagination;
  },
  getPagination(state) {
    return state.pagination;
  },
  items(state) {
    return state.items;
  },
  consumerunits(state) {
    return state.consumer_units;
  },
  config(state) {
    return state.config;
  },
  getGdReports(state) {
    return state.items;
  },
  loggedUser(state) {
    return state.user;
  },
};
